export const isTabOrDesktop = window.innerWidth >= 768;
